import { RawSQL, sql, sqlF } from '../../sqlTemplate';

// For some reason, nested calls to date_cast() run incredibly slowly, so this
// is a hack to avoid nesting them. See this thread for more context:
// https://watershedclimate.slack.com/archives/C05DDNTFTUN/p1687385158852579?thread_ts=1687381805.195479&cid=C05DDNTFTUN
export function dateCastIfNotAlreadyCast(expr: RawSQL): RawSQL {
  const sqlExpr = sql`${expr}`;
  return sqlExpr.startsWith('date_cast(') ? expr : sqlF`date_cast(${expr})`;
}
